export default __webpack_public_path__ + "static/react-1c2c57661752bb179c345c89b5988fd1.png";